import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=ced5360e&scoped=true&"
import script from "./back-top.vue?vue&type=script&lang=js&"
export * from "./back-top.vue?vue&type=script&lang=js&"
import style0 from "./back-top.vue?vue&type=style&index=0&id=ced5360e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced5360e",
  null
  
)

export default component.exports